<div id="afluria">
  @if (firstnode | async; as item) {
    <div class="hero--prod hero--prod--info-hasbg" role="img" aria-label="Adult holding young child" [style.backgroundImage]="'url(' + getBgImage(item.media) + ')'">
      @if (!userLoggedIn) {
        <div class="breadcrumbs--page-nav">
          <div class="container">
            <p><a routerLink="/">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a routerLink="/products">{{"statictext.products" | cxTranslate}}</a><span> &gt; </span><strong>{{"statictext.afluriatxt" | cxTranslate}}</strong></p>
          </div>
        </div>
      }
      <div class="container content_Container">
        <div class="hero--prod__body">
          @if (item?.mediaPicture) {
            <div class="hero--prod__logo">
              <img [src]="getImage(item.mediaPicture)" alt="product logo">
            </div>
          }
          <div class="hero--prod__info">
            <h1 class="hero--prod__header header--2" [innerHTML]="item.headline"></h1>
            <div class="dynamic-content-wrapper" [innerHTML]="item.content" appRouterlinkinterceptor></div>
          </div>
        </div>
      </div>
      <div class="hero--prod__footer">
        <div class="container" [innerHTML]="item.largeparagraphcontent">
        </div>
      </div>
    </div>
  }
</div>